import React from "react";


const Article = () => {
  return (
    <div className="mb-20">
      <div>
        <h2 id="Results_hgt_h"> Results for HGT </h2>
        <hr className="dividergeneral mb-5"></hr>
        <p className="mb-2">
          This results section consists of three main parts :
          <br></br>
          <br></br>
          <ol>
            <li>Experiment for which the secondary colonies were incubated with dUTP for 20 minutes </li>
            <li>Experiment for which the secondary colonies were incubated with dUTP for 30 minutes  </li>
            <li>Control for the 30 minutes dUPT incubations experiment </li>
          </ol>
        </p>
        <h2 className="mt-20" id="20-minutes_h"> 20 minutes incubation </h2>
        <hr className="dividergeneral mb-5"></hr>
        <p className="mb-2">
          As we did not know precisely how much time was needed to incubate our secondary culture with dUTP,
          we opted for 20 minutes at 37°C before doing mini-prep.
        </p>
        <h3 className="mt-10 mb-5" id="Plates-1_h">Plates</h3>
          <figure>
            <img
              id="Figure1"
              src="https://static.igem.wiki/teams/4888/wiki/hgt-results/20min-bl21-cj236-min.png"
              alt="project_description"
              class="centered-image"
              style={{ width: "90%" }}
            />
            <br></br>
            <figcaption>
              <b>
                <u>Figure 1:</u>{" "}
              </b>
              Plates with colonies that integrated our Uplasmid
            </figcaption>
          </figure>
        <h3 className="mt-10 mb-5" id="Fluorescence-1_h">Detecting GFP fluorescence with microscopy</h3>
          <figure>
            <img
              id="Figure1"
              src="https://static.igem.wiki/teams/4888/wiki/hgt-results/microscope1.png"
              alt="project_description"
              class="centered-image"
              style={{ width: "90%" }}
            />
            <br></br>
            <figcaption>
              <b>
                <u>Figure 2:</u>{" "}
              </b>
              GFP detection through fluorescence microscopy
            </figcaption>
          </figure>
        <h3 className="mt-10 mb-5" id="histogram-1_h">Histogram</h3>
          <figure>
              <img
                id="Figure1"
                src="https://static.igem.wiki/teams/4888/wiki/hgt-results/20-minutes-cj236.png"
                alt="project_description"
                class="centered-image"
                style={{ width: "90%" }}
              />
              <br></br>
              <figcaption>
                <b>
                  <u>Figure 3:</u>{" "}
                </b>
                Histogram of viable colonies
              </figcaption>
            </figure>
        <p className="mb-2">
        We observed that CJ236 grew well and expressed the protein, in contrast to the absence 
        of any colonies in BL21. This strongly indicates the inability of our plasmid to be inserted 
        into a UNG- strain. This led us to suspect that the lack of success in BL21 could be attributed
        to the cells' inability to take up foreign DNA, i.e., their lack of competence. Subsequently,
        we repeated the experiment using a different BL21 strain in an effort to address this issue.
        Interesting to point out that for CJ236, as the concentration of dUTP increases the number of 
        viable colonies decreases, leading us to think that the Uplasmid gets less stable and too much uracilation
        in the ampicilin resistance gene inhibit correct expression of the protein. An equilibrium between concentration of dUTP and incubation time has to
        be found to minimize HGT occurence.
        </p>


        <h2 className="mt-20" id="30-minutes_h"> 30 minutes incubation </h2>
        <hr className="dividergeneral mb-5"></hr>
        <p className="mb-2">We repeated the experiment but this time for an incubation time of 30 minutes. We also tested our Uplasmid incorporation in the DH5a strain. </p>
        <h3 className="mt-10 mb-5" id="Plates-2_h">Plates </h3>
        <figure>
            <img
              id="Figure1"
              src="https://static.igem.wiki/teams/4888/wiki/hgt-results/30min-dh5-cj236-min.png"
              alt="project_description"
              class="centered-image"
              style={{ width: "90%" }}
            />
               <img
              id="Figure1"
              src="https://static.igem.wiki/teams/4888/wiki/hgt-results/30min-bl21-min.png"
              alt="project_description"
              class="centered-image"
              style={{ width: "90%" }}
            />
            <br></br>
            <figcaption>
              <b>
                <u>Figure 4:</u>{" "}
              </b>
              Plates with colonies that integrated our Uplasmidd
            </figcaption>
          </figure>
        <h3 className="mt-10 mb-5" id="Fluorescence-2_h">Detecting fluorescence with microscopy</h3>
          <figure>
            <img
              id="Figure1"
              src="https://static.igem.wiki/teams/4888/wiki/hgt-results/30-fluo.png"
              alt="project_description"
              class="centered-image"
              style={{ width: "90%" }}
            />
            <br></br>
            <figcaption>
              <b>
                <u>Figure 5:</u>{" "}
              </b>
              GFP detection through fluorescent microscopy
            </figcaption>
          </figure>
        <h3 className="mt-10 mb-5" id="Histogram-2_h">Histogram</h3>
            <figure>
              <img
                id="Figure1"
                src="https://static.igem.wiki/teams/4888/wiki/hgt-results/30-minutes-cj236.png"
                alt="project_description"
                class="centered-image"
                style={{ width: "90%" }}
              />
              <br></br>
              <figcaption>
                <b>
                  <u>Figure 6:</u>{" "}
                </b>
                Histogram of viable colonies
              </figcaption>
            </figure>

            <p className="mb-2">The histogram highlights  the viability of the different strains for Uplasmid. While BL21 still displayed 
              difficulties in growing on the plate, DH5a formed colonies, even though  the 
              numbers were small compared to the numbers of CJ236, CJ236 colonies were 15 
              times higher than on DH5a. This further demonstrates as on figure 3 the viability of dut-/ung- strains 
              over dut+/ung+ ones, indicating that we have indeed found a system to prevent horizontal gene transfer.</p>

        <h2 className="mt-20" id="30-minutes-control_h"> 30 minutes incubation (Control) </h2>
        <hr className="dividergeneral mb-5"></hr>
        <p className="mb-2">
        In order to confirm that our results were indeed attributable to the UNG/DUT gene mutations,
        we made the decision to conduct a repeat of the experiment. This time, we employed DH5a as
        our vector for the potential production of a Uplasmid.
        </p>
        <h3 className="mt-10 mb-5" id="Plates-3_h">Plates</h3>
            <figure>
              <img
                id="Figure1"
                src="https://static.igem.wiki/teams/4888/wiki/hgt-results/30-control-min.png"
                alt="project_description"
                class="centered-image"
                style={{ width: "90%" }}
              />
              <br></br>
              <figcaption>
                <b>
                  <u>Figure 7:</u>{" "}
                </b>
                Plates with colonies that integrated our Uplasmid
              </figcaption>
            </figure>
        <h3 className="mt-10 mb-5" id="Fluorescence-3_h">Detection of fluorescence with microscopy</h3>
          <figure>
              <img
                id="Figure1"
                src="https://static.igem.wiki/teams/4888/wiki/hgt-results/control.png"
                alt="project_description"
                class="centered-image"
                style={{ width: "90%" }}
              />
              <br></br>
              <figcaption>
                <b>
                  <u>Figure 8:</u>{" "}
                </b>
                GFP detection through fluorescence microscopy
              </figcaption>
            </figure>

        <h3 className="mt-10 mb-5" id= "Histogram-3_h">Histogram</h3>
            <figure>
              <img
                id="Figure1"
                src="https://static.igem.wiki/teams/4888/wiki/hgt-results/con.png"
                alt="project_description"
                class="centered-image"
                style={{ width: "90%" }}
              />
              <br></br>
              <figcaption>
                <b>
                  <u>Figure 9:</u>{" "}
                </b>
                Histogram of viable colonies (control)
              </figcaption>
            </figure>
            <p className="mb-5">The histogram highlights a tendency of CJ236 to grow more than the other two strains even though  the numbers 
              are not as divergent as on figure 6. For example, on the condition 10 ul/ml, the number of colonies are almost the same. 
              This suggests than rather than a Uplasmid, we simply generated the same plasmid with which we transformed DH5a on a 
              dUTP medium to test the control. With these experiments, we have successfully demonstrated that the production of plasmids by a dut-/ung- strain is essential 
              for an afterward transformation into a bacterium  that can tolerate this Uplasmid.</p>
      </div>
    </div>
  );
};

export default Article;
